import { TextField, InputAdornment } from "@mui/material";
import { PhoneIcon } from "@heroicons/react/24/outline";
import React, { useState, useEffect } from "react";

interface PhoneFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  validate?: boolean; 
  showError?: boolean;
}

const PhoneField: React.FC<PhoneFieldProps> = ({
  label,
  name,
  value,
  onChange,
  required = false,
  validate = true,
  showError = true,
}) => {
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");

//   const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10);
//     const modifiedEvent = {
//       ...e,
//       target: {
//         ...e.target,
//         value: digitsOnly,
//       },
//     };
//     onChange(modifiedEvent as React.ChangeEvent<HTMLInputElement>);
//   };

const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only digits, max 10
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10);
  
    onChange({
        target: {
          name: name,
          value: digitsOnly,
        },
      } as React.ChangeEvent<HTMLInputElement>);
  };
  

  useEffect(() => {
    if (!validate) return;

    if (!value) {
      setError(required);
      setHelperText(required ? "Phone number is required" : "");
    } else if (!/^[6-9]\d{9}$/.test(value)) {
      setError(true);
      setHelperText("Invalid phone number");
    } else {
      setError(false);
      setHelperText("");
    }
  }, [value, required, validate]);

  return (
    <TextField
      fullWidth
      required={required}
      name={name}
      label={label}
      type="tel"
      value={value}
      onChange={handleInput}
      error={showError && error}
      helperText={showError && error ? helperText : ""}
      inputProps={{ maxLength: 10 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <PhoneIcon className="h-5 w-5 text-gray-500" />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PhoneField;
